import { EntityId, PayloadAction, Update, createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { createNewFiles } from './actions';

export interface SourcePageFullDetail {
    sourceFileId: EntityId;
    sourceFileRefId?: string | number;
    sourceFilePageNr: number;
    sourcePageId: EntityId;
}

export interface FileDesc {
    filename: string;
    size: number;
    blobURL: string;
    details: SourcePageFullDetail[];
    pageId: EntityId;
    removed: boolean;
    id: string;
}

export const newFilesAdapter = createEntityAdapter<FileDesc>({
    selectId: model => model.id
});

export const newFilesSlice = createSlice({
    name: 'newFiles',
    initialState: newFilesAdapter.getInitialState({ loading: false }),
    reducers: {
        setUserFilename(state, { payload }: PayloadAction<Update<FileDesc>>) {
            newFilesAdapter.updateOne(state, payload);
        }
    },
    extraReducers: builder => {
        builder.addCase(createNewFiles.pending, state => {
            state.loading = true;
        });
        builder.addCase(createNewFiles.fulfilled, (state, action) => {
            state.loading = false;
            newFilesAdapter.setAll(state, action.payload);
        });
    }
});

export const { setUserFilename: setNewFilename } = newFilesSlice.actions;
